<button mat-fab cdkDrag aria-label="History" matTooltip="History" class="task-manager-button"
  (click)="toggleTaskManager()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <mat-icon svgIcon="history"></mat-icon>
</button>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="taskManagerIsOpen"
  [cdkConnectedOverlayPanelClass]="'task-manager-overlay-panel'">
  <div cdkDrag class="task-manager-overlay-container mat-elevation-z15">
    <app-task-manager [data]="praticaProgressService.selectedPratica" (close)="toggleTaskManager()"></app-task-manager>

  </div>

</ng-template>
